import {gql} from 'apollo-angular';

export const SET_GAME_CATEGORIES_TEACHER = gql`
  query SetGameCategoriesTeacher($schoolClassId: Int!, $categoryIds: [Int!]!) {
    setGameCategoriesTeacher(schoolClassID: $schoolClassId, categoryIDs: $categoryIds) {
      type
      message
    }
  }
`;
